import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceGateReviewPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-review"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/review")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading...</div>}>
      <InvoiceGateReviewPage />
    </Suspense>
  ),
});
